"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$arithFormula = exports.arithFormulaToLines = exports.arithFormulaControl = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const inline_1 = require("../../../node/cst/inline");
const _any_1 = __importStar(require("./$any"));
const el_1 = require("../../../node/el");
exports.arithFormulaControl = ":arith-formula:";
/**
 * The renderer for {@link std.ArithFormula}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$arithFormula.spec.ts) for examples.
 */
const arithFormulaToLines = (arithFormula, indentTexts) => {
    const lines = [];
    lines.push(new line_1.OtherLine({
        range: null,
        indentTexts,
        controls: [
            new inline_1.Control(exports.arithFormulaControl, null, "", null),
        ],
        sentencesArray: [],
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    lines.push(...arithFormula.children.map(c => (0, _any_1.anyToLines)(c, childrenIndentTexts)).flat());
    return lines;
};
exports.arithFormulaToLines = arithFormulaToLines;
const $arithFormulaChildrenBlock = (0, util_1.makeIndentBlockWithCaptureRule)("$arithFormulaChildrenBlock", (factory_1.factory.ref(() => _any_1.default)));
/**
 * The parser rule for {@link std.ArithFormula}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$arithFormula.spec.ts) for examples.
 */
exports.$arithFormula = factory_1.factory
    .withName("arithFormula")
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH
        && item.line.sentencesArray.length === 0
        && item.line.controls.some(c => c.control === exports.arithFormulaControl)) {
        return item;
    }
    else {
        return null;
    }
}), "labelLine")
    .and(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(r => r
    .zeroOrOne(() => $arithFormulaChildrenBlock), "childrenBlock")
    .action(({ labelLine, childrenBlock }) => {
    const children = [];
    const errors = [];
    if (childrenBlock) {
        children.push(...childrenBlock.value.flat().map(v => v.value).flat());
        errors.push(...childrenBlock.value.flat().map(v => v.errors).flat());
        errors.push(...childrenBlock.errors);
    }
    const pos = labelLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const arithFormula = (0, std_1.newStdEL)("ArithFormula", {}, children, range);
    return {
        value: arithFormula,
        errors,
    };
}));
exports.default = exports.$arithFormula;
//# sourceMappingURL=$arithFormula.js.map